import React from "react";
import styles from "./styles.module.scss";

const flows = {
  customerIntake: ["PREPARED", "APPROVED", "RUNNING", "RETRY", "REVIEW_REQUIRED", "UNCERTAIN", "COMPLETE", "REVOKED"],
  commercialHandoff: ["IN_FLIGHT", "VERIFIED", "UNCERTAIN"],
  existingBoletos: ["PENDING", "RESERVED", "ACCEPTED", "UNCERTAIN", "CANCELLED", "HELD"],
};
const flags = ["commercialHandoffEnabled", "customerCreationEnabled", "customerWorkerEnabled", "newBoletosEnabled", "existingBoletosEnabled", "recurringEmailEnabled", "emailPilotEnabled"];
export function validAutomationObservation(data) {
  return data?.readOnly === true && data.available === true &&
    data.workerHealth === "NOT_OBSERVED" && data.deliveryConfirmation === "NOT_INFERRED" &&
    flags.every(key => typeof data.configuration?.[key] === "boolean") &&
    data.units?.customerIntake === "JOBS" && data.units?.commercialHandoff === "FIELDS" && data.units?.existingBoletos === "DELIVERIES" &&
    Object.entries(flows).every(([flow, states]) => states.every(state => Number.isSafeInteger(data.counts?.[flow]?.[state]) && data.counts[flow][state] >= 0) && Number.isSafeInteger(states.reduce((sum, state) => sum + data.counts[flow][state], 0)));
}
export default function FinancialAutomationObservation({ data }) {
  if (!validAutomationObservation(data)) return <p role="status">Acompanhamento das automações indisponível nesta consulta. Isso não indica filas vazias ou robôs ativos.</p>;
  const c = data.counts, settings = data.configuration;
  const status = enabled => enabled ? "Habilitado na configuração; funcionamento ainda precisa ser confirmado." : "Desligado";
  const uncertain = c.commercialHandoff.IN_FLIGHT + c.commercialHandoff.UNCERTAIN + c.customerIntake.UNCERTAIN + c.existingBoletos.RESERVED + c.existingBoletos.UNCERTAIN;
  return <section className={styles.panel} aria-label="Situação das automações financeiras">
    <div className={styles.panelHeader}><div><span>Rotinas financeiras</span><h2>Automações e pendências</h2></div></div>
    <p>Posição registrada no portal. A configuração habilitada não comprova que o robô está funcionando ou que o cliente recebeu a mensagem.</p>
    {uncertain > 0 && <p role="alert">Há {uncertain} registro(s) com execução em andamento ou resultado a conferir. Confira o histórico antes de repetir qualquer operação.</p>}
    <div className={styles.channelGrid}>
      <article className={styles.channelCard}>
        <h3>Comercial → Financeiro</h3><p>{status(settings.commercialHandoffEnabled)}</p>
        <p>Campos conferidos: <strong>{c.commercialHandoff.VERIFIED}</strong></p>
        <p>Campos em andamento ou a conferir: <strong>{c.commercialHandoff.IN_FLIGHT + c.commercialHandoff.UNCERTAIN}</strong></p>
      </article>
      <article className={styles.channelCard}>
        <h3>Cadastro no Asaas</h3><p>{status(settings.customerCreationEnabled && settings.customerWorkerEnabled)}</p>
        <p>Cadastros concluídos: <strong>{c.customerIntake.COMPLETE}</strong></p>
        <p>Aguardando: <strong>{c.customerIntake.PREPARED + c.customerIntake.APPROVED + c.customerIntake.RUNNING + c.customerIntake.RETRY}</strong></p>
        <p>Precisam de conferência: <strong>{c.customerIntake.REVIEW_REQUIRED + c.customerIntake.UNCERTAIN}</strong></p>
      </article>
      <article className={styles.channelCard}>
        <h3>Boletos existentes</h3><p>{status(settings.existingBoletosEnabled)}</p>
        <p>Aguardando: <strong>{c.existingBoletos.PENDING}</strong></p>
        <p>Retidos ou a conferir: <strong>{c.existingBoletos.HELD + c.existingBoletos.RESERVED + c.existingBoletos.UNCERTAIN}</strong></p>
        <p>Aceitos pelo serviço de e-mail: <strong>{c.existingBoletos.ACCEPTED}</strong></p>
        <p>Aceite não confirma recebimento pelo cliente.</p>
      </article>
    </div>
    <p>Novos boletos: {status(settings.newBoletosEnabled)}</p>
    <p>E-mails recorrentes: {status(settings.recurringEmailEnabled)}</p>
    <p>Piloto individual de e-mail: {status(settings.emailPilotEnabled)}</p>
    <p>As contagens mostram registros do portal; não representam toda a carteira do Asaas. Campos copiados, cadastros e entregas são unidades diferentes.</p>
  </section>;
}
